import { render, staticRenderFns } from "./UploadScreen.vue?vue&type=template&id=e96b2bbe&scoped=true&"
import script from "./UploadScreen.vue?vue&type=script&lang=js&"
export * from "./UploadScreen.vue?vue&type=script&lang=js&"
import style0 from "./UploadScreen.vue?vue&type=style&index=0&id=e96b2bbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96b2bbe",
  null
  
)

export default component.exports